import * as Sentry from '@sentry/react'

export const initSentry = () => {
  Sentry.init({
    dsn:
      'https://7d3fa09b98efb06f4ddd0a434291af5c@o1220724.ingest.us.sentry.io/4511337922101248',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^https:\/\/admin\.us\.datacubed\.com/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

export const logSentryEvent = ({ message, level = 'info', tags = {}, contexts = {}, breadcrumb, error }) => {
  Sentry.withScope(scope => {
    scope.setTag('application', 'Admin Panel')

    Object.entries(tags || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        scope.setTag(key, value)
      }
    })

    Object.entries(contexts || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        scope.setContext(key, value)
      }
    })

    scope.setLevel(level)

    if (breadcrumb?.message) {
      Sentry.addBreadcrumb({
        category: breadcrumb.category || 'app',
        message: breadcrumb.message,
        level: breadcrumb.level || level,
      })
    }

    if (error) {
      Sentry.captureException(error)
      return
    }

    Sentry.captureMessage(message || 'Sentry event')
  })
}
